import { z } from 'zod';

const WEBVIEW_EVENT_LIST = ['ROUTER', 'ONLOAD', 'ON_REFRESH', 'ON_FINISHED_REFRESH', 'AUTH'] as const;
export type WebViewEventListType = (typeof WEBVIEW_EVENT_LIST)[number];

export const WEBVIEW_EVENT_TYPE = {
  ROUTER: 'ROUTER',
  APP_INITIALIZE: 'APP_INITIALIZE',
  ONLOAD: 'ONLOAD',
  ON_REFRESH: 'ON_REFRESH',
  ON_FINISHED_REFRESH: 'ON_FINISHED_REFRESH',
  AUTH: 'AUTH',
  KEYBOARD: 'KEYBOARD',
  SNACKBAR: 'SNACKBAR',
  SET_SEARCHPARAMS: 'SET_SEARCHPARAMS',
  PING: 'PING',
} as const;

export const onLoadSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.ONLOAD),
});

export const onRefreshSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.ON_REFRESH),
});

export const onFinishedRefreshSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.ON_FINISHED_REFRESH),
});

export const authSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.AUTH),
  data: z.object({
    userID: z.number(),
    accessToken: z.string(),
    refreshToken: z.string(),
    userRole: z.string(),
  }),
});

export const routerSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.ROUTER),
  data: z.object({
    url: z.string().optional(),
    goBack: z.boolean().optional(),
  }),
});

export const snackbarEventSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.SNACKBAR),
  data: z.object({
    text: z.string(),
    duration: z.number().optional(),
  }),
});

export const appInitializedEventSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.APP_INITIALIZE),
  data: z.object({
    version: z.string(),
    screenKey: z.string(),
  }),
});

export const setSearchParamsEventSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.SET_SEARCHPARAMS),
  data: z.any(),
});

export const pingEventSchema = z.object({
  type: z.literal(WEBVIEW_EVENT_TYPE.PING),
  data: z.any(),
});

export const webViewEventSchema = z.union([
  authSchema,
  routerSchema,
  onLoadSchema,
  onRefreshSchema,
  onFinishedRefreshSchema,
  snackbarEventSchema,
  setSearchParamsEventSchema,
  appInitializedEventSchema,
  pingEventSchema,
]);

export type WebViewEventType = z.infer<typeof webViewEventSchema>;

export type AuthSchemaType = z.infer<typeof authSchema>;
export type RouterSchemaType = z.infer<typeof routerSchema>;
export type AppInitializeSchemaType = z.infer<typeof appInitializedEventSchema>;
export type SetSearchParamsEventSchemaType = z.infer<typeof setSearchParamsEventSchema>;

export type SnackbarEventSchemaType = z.infer<typeof snackbarEventSchema>;
export type PingEventSchemaType = z.infer<typeof pingEventSchema>;
